import { render, staticRenderFns } from "./dui-icon-facebook.vue?vue&type=template&id=4a5659d2&scoped=true&"
var script = {}
import style0 from "./dui-icon-facebook.vue?vue&type=style&index=0&id=4a5659d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5659d2",
  null
  
)

export default component.exports